<template>
  <div class="home">
    <div class="banner">
      <b-carousel
          id="home-carousel"
          style="text-shadow: 0px 0px 2px #000"
          fade
          indicators

          v-model="activeSlide"
        >
          <b-carousel-slide>
            <template v-slot:img>
              <img class="d-block img-fluid w-100" src="@/assets/InformationSecurity.png" />
            </template>
            <div class="carousel-caption d-none d-md-block text-left">
              <h1>Information Security</h1>
              <p>We provide regulatory compliance, industry standard practices/frameworks, and cutting edge hardware/software protection.</p>
              <p>
                <b-button to="/infosec" size="lg" variant="primary">Learn more</b-button>
              </p>
            </div>
          </b-carousel-slide>
          <b-carousel-slide>
            <template v-slot:img>
              <img class="d-block img-fluid w-100" src="@/assets/InformationTechnology.jpg" />
            </template>
            <div class="carousel-caption d-none d-md-block text-left">
                <h1>Information Technology</h1>
                <p>We provide monitoring services, hardware support/upgrades, and policy/procedure guidance.</p>
                <p><b-button to="/technology" size="lg" variant="primary">Learn more</b-button></p>
            </div>
          </b-carousel-slide>
          <b-carousel-slide>
            <template v-slot:img>
              <img class="d-block img-fluid w-100" src="@/assets/Cybersecurity.png" />
            </template>
            <div class="carousel-caption d-none d-md-block text-left">
                <h1>Cybersecurity</h1>
                <p>Strategy is a big part of protecting.</p>
                <p><b-button to="/cybersecurity" size="lg" variant="primary">Learn more</b-button></p>
            </div>
          </b-carousel-slide>
      </b-carousel>
    </div>

<!-- 
    <div class="banner">
          <div id="home-carousel" class="carousel slide full-banner" data-ride="carousel">
            <ol class="carousel-indicators">
                <li data-target="#home-carousel" data-slide-to="0" class="active"></li>
                <li data-target="#home-carousel" data-slide-to="1" class=""></li>
                <li data-target="#home-carousel" data-slide-to="2" class=""></li>
            </ol>
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img class="d-block img-fluid" src="@/assets/InformationSecurity.png" />
                    <div class="carousel-caption d-none d-md-block text-left">
                        <h1>Information Security</h1>
                        <p>We provide regulatory compliance, industry standard practices/frameworks, and cutting edge hardware/software protection.</p>
                        <p><a class="btn btn-lg btn-primary" asp-controller="Home" asp-action="InfoSec" role="button">Learn more</a></p>
                    </div>
                </div>
                <div class="carousel-item">
                    <img class="d-block img-fluid" src="@/assets/InformationTechnology.jpg" />
                    <div class="carousel-caption d-none d-md-block text-left">
                        <h1>Information Technology</h1>
                        <p>We provide monitoring services, hardware support/upgrades, and policy/procedure guidance.</p>
                        <p><a class="btn btn-lg btn-primary" asp-controller="Home" asp-action="Technology" role="button">Learn more</a></p>
                    </div>
                </div>
                <div class="carousel-item">
                    <img class="d-block img-fluid" src="@/assets/Cybersecurity.png" />
                    <div class="carousel-caption d-none d-md-block text-left">
                        <h1>Cybersecurity</h1>
                        <p>Strategy is a big part of protecting.</p>
                        <p><a class="btn btn-lg btn-primary" asp-controller="Home" asp-action="Cybersecurity" role="button">Learn more</a></p>
                    </div>
                </div>
            </div>
            <a class="carousel-control-prev" href="#home-carousel" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#home-carousel" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div> -->



    <div class="container marketing">

        <!-- START THE FEATURETTES -->
      <div class="row featurette">
          <div class="col-md-7">
              <div class="card nist-identify">
                  <h2 class="card-header featurette-heading">
                      Identify
                  </h2>
                  <ul class="list-group list-group-flush">
                      <li class="list-group-item">Asset Management</li>
                      <li class="list-group-item">Business Environment</li>
                      <li class="list-group-item">Governance</li>
                      <li class="list-group-item">Risk Assessment</li>
                      <li class="list-group-item">Risk Management Strategy</li>
                  </ul>
              </div>
          </div>
          <div class="col-md-5">
              <img class="featurette-image img-fluid mx-auto" src="@/assets/Indentify.png">
          </div>
      </div>

      <hr class="featurette-divider">

      <div class="row featurette">
          <div class="col-md-7 push-md-5">
              <div class="card nist-protect">
                  <h2 class="card-header featurette-heading">Protect</h2>
                  <ul class="list-group">
                      <li class="list-group-item">Access Control</li>
                      <li class="list-group-item">Awareness &amp; Training</li>
                      <li class="list-group-item">Data Security</li>
                      <li class="list-group-item">Info Protection Process &amp; Procedures</li>
                      <li class="list-group-item">Maintenance</li>
                      <li class="list-group-item">Protective Technology</li>
                  </ul>
              </div>
          </div>
          <div class="col-md-5 pull-md-7">
              <img class="featurette-image img-fluid mx-auto" src="@/assets/Protect.png" />
          </div>
      </div>

      <hr class="featurette-divider">

      <div class="row featurette">
          <div class="col-md-7">
              <div class="card nist-detect">
                  <h2 class="card-header featurette-heading">Detect</h2>
                  <ul class="list-group list-group-flush">
                      <li class="list-group-item">Anomalies &amp; Events</li>
                      <li class="list-group-item">Security Continuous Monitoring</li>
                      <li class="list-group-item">Detection Processes</li>
                  </ul>
              </div>
          </div>
          <div class="col-md-5">
              <img class="featurette-image img-fluid mx-auto" src="@/assets/Detect.png" />
          </div>
      </div>

      <hr class="featurette-divider">

      <div class="row featurette">
          <div class="col-md-7">
              <div class="card nist-respond">
                  <h2 class="card-header featurette-heading">Respond</h2>
                  <ul class="list-group">
                      <li class="list-group-item">Response Planning</li>
                      <li class="list-group-item">Communications</li>
                      <li class="list-group-item">Analysis</li>
                      <li class="list-group-item">Mitigation</li>
                      <li class="list-group-item">Improvements</li>
                  </ul>
              </div>
          </div>
          <div class="col-md-5">
              <img class="featurette-image img-fluid mx-auto" src="@/assets/Respond.png" />
          </div>
      </div>

      <hr class="featurette-divider">

      <div class="row featurette">
          <div class="col-md-7">
              <div class="card nist-recover">
                  <h2 class="card-header featurette-heading">Recover</h2>
                  <ul class="list-group list-group-flush">
                      <li class="list-group-item">Recovery Planning</li>
                      <li class="list-group-item">Improvements</li>
                      <li class="list-group-item">Communications</li>
                  </ul>
              </div>
          </div>
          <div class="col-md-5">
              <img class="featurette-image img-fluid mx-auto" src="@/assets/Recover.png" />
          </div>
      </div>

      <hr class="featurette-divider">
    </div>
  </div>
</template>

<style>
  .banner {
    margin-top: -40px;
    margin-bottom: 40px;
  }
</style>

<script>
// @ is an alias to /src

export default {
  name: "home",
  components: {

  },
  data: function() {
    return {
      activeSlide: 0
    }
  }
};
</script>
